import { c as _c } from "react/compiler-runtime";
interface KeyValueCardProps {
  label: string;
  value: string;
}
function KeyValueCard(t0) {
  const $ = _c(7);
  const {
    label,
    value
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span className="text-muted-foreground truncate text-xs font-medium">{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== value) {
    t2 = <span className="text-foreground line-clamp-2 text-sm leading-tight font-semibold">{value}</span>;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="bg-background border-border flex min-w-0 flex-1 flex-col gap-1 rounded-lg border px-4 py-3">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export { KeyValueCard };